import { render, staticRenderFns } from "./el-text.vue?vue&type=template&id=0170de84&scoped=true"
import script from "./el-text.vue?vue&type=script&lang=js"
export * from "./el-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0170de84",
  null
  
)

export default component.exports